import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  countdown: number = 10;
  private countdownInterval: any;

  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: Meta
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Thank You - NICT Computer Education');
    this.metaService.updateTag({
      name: 'description',
      content: 'Thank you for your interest in NICT Computer Education. Our team will contact you shortly.'
    });

    // Start countdown
    this.startCountdown();

    // Add confetti effect
    this.triggerConfetti();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.navigateHome();
      }
    }, 1000);
  }

  navigateHome(): void {
    this.router.navigate(['/home']);
  }

  navigateToCourses(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.router.navigate(['/courses']);
  }

  triggerConfetti(): void {
    // Simple confetti animation trigger
    setTimeout(() => {
      const confettiContainer = document.querySelector('.confetti-container');
      if (confettiContainer) {
        confettiContainer.classList.add('active');
      }
    }, 100);
  }
}
